import type { AccountBuyerObjectType, AccountSellerObjectType } from '@/graphql/graphql';
import { createContext, useContext } from 'react';

export interface UserData {
    name: string;
    id: string | null;
    user: AccountSellerObjectType | AccountBuyerObjectType | null;
    isAdmin: boolean;
    isSeller: boolean;
    isBuyer: boolean;
    isAnonymous: boolean;
    isReadOnly: boolean;
    loading: boolean;
}

export const ANONYMOUS_ID = '0000-0000-0000-0000';

export const UserDataContext = createContext<UserData>({
    name: '',
    id: ANONYMOUS_ID,
    user: null,
    isAdmin: false,
    isSeller: false,
    isBuyer: false,
    isAnonymous: false,
    isReadOnly: true,
    loading: true,
});

export const useUserData = () => useContext(UserDataContext);
